
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import 'katex/dist/katex.min.css';

/**
 * MathRenderer Component
 * 
 * Standardized component for rendering text mixed with LaTeX math.
 * Uses ReactMarkdown with remark-math and rehype-katex features.
 * Supports HTML content via rehype-raw.
 * 
 * Props:
 * - content: string (The text/markdown content to render)
 * - className: string (Optional container classes)
 * - inline: boolean (If true, renders as span instead of div (block))
 */
const MathRenderer = ({ content, className = '', inline = false }) => {
    if (!content) return null;

    // Helper to preprocess content if needed
    // e.g. converting \[ \] to $$ $$ if remark-math expects specific formats
    // but usually standard patterns work fine.

    // Ensure content is a string
    const safeContent = typeof content === 'string' ? content : String(content);

    const components = {
        // Custom component overrides if needed
        p: ({ node, ...props }) => inline ? <span {...props} /> : <p className="mb-2 last:mb-0" {...props} />
    };

    return (
        <div className={`math-renderer ${className} ${inline ? 'inline-block' : 'block'}`}>
            <ReactMarkdown
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeRaw, rehypeKatex]}
                components={components}
            >
                {safeContent}
            </ReactMarkdown>
        </div>
    );
};

export default MathRenderer;
